<template>
  <div class="relative overflow-hidden">
    <div class="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div class="gradient-banner-bg absolute inset-0" />
      <div class="gradient-banner-bg__top absolute inset-0" />
      <div class="gradient-banner-bg__grain absolute inset-0" />
      <div class="gradient-banner-bg__bottom absolute inset-0" />
      <div class="gradient-banner-bg__hue absolute inset-0" />
    </div>
    <div class="relative z-10 h-full">
      <slot />
    </div>
  </div>
</template>

<style scoped>
/* Figma dark gradient banner — WebP layer stack */
.gradient-banner-bg {
  background-color: #030021;
}

.gradient-banner-bg__top {
  background: url('/images/advisory/mmm-overview-banner-layer-top.webp') center / cover no-repeat;
}

.gradient-banner-bg__grain {
  background: url('/images/advisory/mmm-overview-banner-layer-grain.webp') center / cover no-repeat;
  opacity: 0.9;
}

.gradient-banner-bg__bottom {
  background: url('/images/advisory/mmm-overview-banner-layer-bottom.webp') center bottom / cover no-repeat;
}

.gradient-banner-bg__hue {
  background-color: #1a54c4;
  mix-blend-mode: hue;
}
</style>
